import type { Arrangement } from './arrangement'

// Zredukowane z 5 do 3 kategorii — "Jakość" i "Serwis" łączą się w "Awaria" (wada
// jakościowa / przegląd / naprawa to w praktyce zawsze problem ze sprzętem lub
// procesem), a "Braki" łączy się w "Magazyn" (naturalne dopasowanie tematyczne).
export type IncidentCategory = 'Awaria' | 'BHP' | 'Magazyn'

export interface IncidentForm {
  lokalizacja: string
  obiekt: string
  typ: string
  waznosc: 'niska' | 'średnia' | 'wysoka' | 'pilna' | string
  opis: string
  polecenia: string
  ppe: string
  kategoria?: IncidentCategory | string
  polecenia_arr?: Arrangement[]
}

export const EMPTY_INCIDENT: IncidentForm = {
  lokalizacja: '',
  obiekt: '',
  typ: '',
  waznosc: '',
  opis: '',
  polecenia: '',
  ppe: '',
  kategoria: '',
}
